export default __webpack_public_path__ + "static/media/DashboardFiller.d2ab536f264d9e1fd1ca70331666e711.webp";